function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtboard10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.88898,
    height: 62.98651,
    viewBox: "0 0 57.88898 62.98651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M55.88498,40.98926V21.98926c-.00037-3.74876-2.00049-7.21263-5.24701-9.08701L34.18698,3.40225c-3.24677-1.875-7.24725-1.875-10.49402,0L7.24197,12.90225c-3.24628,1.8745-5.24603,5.33839-5.24597,9.08701v19c-.00006,3.74861,1.99969,7.21251,5.24597,9.08701l16.45099,9.5c3.24677,1.875,7.24725,1.875,10.49402,0l16.45099-9.5c3.24652-1.87437,5.24664-5.33824,5.24701-9.08701",
    style: {
      fill: "#5dbfc7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M55.88898,40.99326V21.99326c-.00037-3.74876-2.00049-7.21263-5.24701-9.08701L34.19098,3.40625c-3.24677-1.875-7.24725-1.875-10.49402,0L7.24597,12.90625c-3.24628,1.8745-5.24603,5.33839-5.24597,9.08701v19c-.00006,3.74861,1.99969,7.21251,5.24597,9.08701l16.45099,9.5c3.24677,1.875,7.24725,1.875,10.49402,0l16.45099-9.5c3.24652-1.87437,5.24664-5.33824,5.24701-9.08701Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M45.42799,24.41427l-15.777,18.5h-6.725l15.8-18.5h6.702Zm-10.466,0l-15.777,18.5h-6.725l15.8-18.5h6.702Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard10);
export default __webpack_public_path__ + "static/media/Artboard_10.6fa201c174672fb66f2ab71edb90282f.svg";
export { ForwardRef as ReactComponent };